// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wholesale-page{flex-grow:1;padding-bottom:40px}.wholesale-page button{margin:0 auto}@media only screen and (min-width:992px){.wholesale-page{padding-bottom:56px}}.wholesale-page__text{margin-bottom:20px;text-align:center}@media only screen and (min-width:992px){.wholesale-page__text{max-width:900px;margin:0 auto 20px}}.wholesale-page__button{width:100%;max-width:320px}", ""]);
// Exports
module.exports = exports;
